class TeamMember extends HTMLElement {
  constructor() {
    super();
    this.seeWatch = this.querySelector('.team-member__see-watch');
    this.back = this.querySelector('.icon-arrow');

    this.seeWatch.addEventListener('click', this.onSeeWatchClick.bind(this));
    this.back.addEventListener('click', this.onBackClick.bind(this));
  }

  onSeeWatchClick() {
    this.classList.add('flipped');
  }

  onBackClick() {
    this.classList.remove('flipped');
  }
}

customElements.define('team-member', TeamMember);